export default "__VITE_ASSET__CCh9OTin__"